var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloud08(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 328.977,
    height: 217.959,
    viewBox: "0 0 328.977 217.959",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M32.972 70.54c-.4-2.312-.618-4.683-.618-7.106 0-22.934 18.592-41.524 41.524-41.524 4.138 0 8.13.613 11.903 1.74C98.31 9.172 116.804 0 137.45 0c31.146 0 57.403 20.847 65.63 49.34 6.616-2.802 13.892-4.353 21.528-4.353 30.19 0 54.708 24.226 55.21 54.297 2.34-.404 4.74-.627 7.193-.627 23.175 0 41.966 18.787 41.966 41.964s-18.79 41.966-41.965 41.966h-32.687c-6.212 6.935-15.23 11.3-25.27 11.3-9.424 0-17.947-3.845-24.094-10.048-13.068 14.787-32.163 24.12-53.446 24.12-18.86 0-35.998-7.333-48.75-19.288-10.06 5.79-21.717 9.117-34.158 9.117C30.716 197.787 0 167.07 0 129.177c0-24.84 13.202-46.597 32.972-58.638z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud08);
export default __webpack_public_path__ + "static/media/cloud-08.1df7a281505b8361ca277d4a718ccb59.svg";
export { ForwardRef as ReactComponent };